module.exports = __webpack_public_path__ + "h5/img/invite-b.87a692a8.png";